import { FC } from 'react';

import Card from 'components/atoms/Card';

import styles from './DescriptionListItem.module.scss';

const QuestionPrefix = () => <p className={styles['question-prefix']}>Q</p>;

interface Props {
  descriptionDetails: string | React.ReactNode;
  descriptionTermPrefix?: string | React.ReactNode;
  descriptionTermText: string;
}

const DescriptionListItem: FC<Props> = ({
  descriptionDetails,
  descriptionTermPrefix,
  descriptionTermText,
}) => (
  <>
    <dt className={styles['text']}>
      {descriptionTermPrefix && descriptionTermPrefix}
      <p className={styles['description-term-text']}>{descriptionTermText}</p>
    </dt>
    <dd>
      <Card>
        {typeof descriptionDetails === 'string' ? (
          <div dangerouslySetInnerHTML={{ __html: descriptionDetails }} />
        ) : (
          descriptionDetails
        )}
      </Card>
    </dd>
  </>
);
export type { Props as DescriptionListItemProps };
export { QuestionPrefix };
export default DescriptionListItem;
